import React, { useState, useEffect } from "react"

import { getGalleryPage } from "services/photo-upload"
import GalleryScreen from "./Gallery"

// GalleryScreenHOC has logic to deal with API service integration

const GalleryScreenHOC = ({ breakId, stepId, userUpload, isActive }) => {
  const ITEMS_PER_PAGE = 8

  const [items, setItems] = useState([])
  const [totalPages, setTotalPages] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)

  const [isLoading, setIsLoading] = useState(false)

  const handlePageClick = async(clickedPageNumber) => {
    // console.log(`handlePaginatedItemClick`, clickedPageNumber)
    //onPageClick(clickedPageNumber)
    await setCurrentPage(clickedPageNumber)
    doItemFetch(clickedPageNumber)
  }

  const loadGalleryData = async function(page=currentPage, itemsPerPage = 8) {
    let ret = []
    try {
      let response = await getGalleryPage(breakId, stepId, page-1, itemsPerPage)
      if (response.status === 200) {
        const body = await response.json()
        if (body.totalEntries && totalPages === null) {
          setTotalPages(Math.ceil(body.totalEntries / ITEMS_PER_PAGE))
        }
        ret = body.assetIds
      }
    } catch (e) {
      console.log(`issue getting ugc gallery: ${e}`)
    }
    if (ret.length > 0) {
      return ret.map(function(item) {
        return `https://s3.amazonaws.com/dbugc_prod/${item}`
      })
    } else {
      return ret
    }
  }

  //Get gallery items from api, and combine with local user image.
  const doItemFetch = async function(page = currentPage) {
    let galleryItems = []
    setIsLoading(true)
    if (page === 1) {
      let items = await loadGalleryData(page, 7)
      galleryItems = [userUpload].concat(items)
    } else {
      galleryItems = await loadGalleryData(page, 8)
    }

    setItems(galleryItems)
    setIsLoading(false)
  }

  useEffect(() => {
    console.log("Fetch gallery items")
    doItemFetch()
  }, [isActive])

  return (
    <>
      <GalleryScreen items={items} currentPage={currentPage} totalPages={totalPages} onPageClick={handlePageClick} isLoading={isLoading} />
    </>
  )
}
export default GalleryScreenHOC
